var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100px","width":"100%","text-align":"center","vertical-align":"center","line-height":"100px"}},[_vm._v("暂无数据")])}
var staticRenderFns = []

export { render, staticRenderFns }